let url = '/api'
let Imhost = 'http://miaopay.testxyz115.com:20009'
let qiuniuUrl = 'testpay.offlinesalon.com/'
let imgApi = 'http://3.1.171.240:8088/'
console.log("NODE_ENV:" + process.env.NODE_ENV)

if (process.env.NODE_ENV === 'production') {
  //   url = 'http://aws.agency.6o9o.net:10002/api'
  //   Imhost = 'http://h5.im.kh6699.com'
  //   qiuniuUrl = 'http://im.beierche.net/'
  url = 'https://api-agency.lcmlqopr.cc/api'
  Imhost = 'https://h5.im.coma2n4b.com'
  qiuniuUrl = 'https://im.yhkb1688.com/'
  imgApi = 'http://aws.agency.6o9o.net:8080/'
} else if (process.env.NODE_ENV === 'test') {
  url = 'http://agency-front.test_web.hjdz668.com/api'
  Imhost = 'http://miaopay.testxyz115.com:20009'
  qiuniuUrl = 'http://testpay.offlinesalon.com/'
  imgApi = 'http://3.1.171.240:8088/'
} else if (process.env.NODE_ENV === 'dev') {
  url = 'http://agency-front.dev_web.hjdz668.com/api'
  Imhost = 'http://itpay-im.dev_web.hjdz668.com'
  qiuniuUrl = 'http://testpay.offlinesalon.com/'
  imgApi = 'http://agency-im.kanonawwx.com/'
  console.log("--- Imhost:" + Imhost);
}


export function getApiHost() {
  return url
}

export function getImHost() {
  return Imhost
}

export function getQiuUrl() {
  return qiuniuUrl
}


export function getImgApiHost() {
  return imgApi;
}
